/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0[_ngcontent-%COMP%], 500[_ngcontent-%COMP%];0[_ngcontent-%COMP%], 700[_ngcontent-%COMP%];1[_ngcontent-%COMP%], 400&display=swap)[_ngcontent-%COMP%];.phone-number-footer[_ngcontent-%COMP%]{background-color:#f8f9fc;color:#9da2bd;padding:1rem;font-size:14px;line-height:130%;border-radius:0 0 8px 8px}.phone-number-body[_ngcontent-%COMP%]{font-size:12px}.phone-number-header[_ngcontent-%COMP%]{margin-bottom:1rem}"];
export { styles as styles };
